import { operatorNames } from '@mks/analytics-core/widgets/expressioneditor/tools/_operatorNames';

/** Доработка описаний элементов редактора выражений. */
function patchExpressionEditorDescriptions() {
    if (Array.isArray(operatorNames)) {
        const parenthesisOp = operatorNames.find((op) => op.text === '()');
        if (parenthesisOp != null) {
            // Для оператора '()' отсутствует идентификатор описания, добавляем.
            parenthesisOp.descriptionStringId = 'ExpressionEditorStringId.Operator_Brackets';
        }
    }
}

export {
    patchExpressionEditorDescriptions
}
